
<div class="ms-login-wrapper">
  <!-- Top Right Floating Theme Switcher -->
  <div class="ms-login-theme-switcher dropdown">
    <button type="button" class="ms-theme-dots-btn" id="branchThemeDropdown" data-toggle="dropdown" title="Select Application Theme">
      <i class="fas fa-palette margin-right-6px"></i>
      <span>Theme</span>
      <i class="fas fa-ellipsis-v margin-left-6px"></i>
    </button>
    <div class="dropdown-menu dropdown-menu-right ms-theme-dropdown-menu p-0 shadow-lg" aria-labelledby="branchThemeDropdown">
      <div class="ms-theme-popup-header">
        <div class="d-flex align-items-center justify-content-between">
          <span class="font-weight-bold font-size-13px text-dark">
            <i class="fas fa-palette text-primary margin-right-6px"></i> Application Themes
          </span>
          <span class="badge badge-pill badge-primary font-size-10px">5 Themes</span>
        </div>
      </div>
      <div class="ms-theme-popup-body">
        <div class="ms-theme-option-item" *ngFor="let t of themes" (click)="selectTheme(t.id)" [class.active]="currentTheme === t.id">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <span class="ms-theme-color-badge" [style.background]="t.previewGradient"></span>
              <div class="margin-left-10px">
                <div class="font-weight-bold font-size-12px text-dark">{{t.name}}</div>
                <div class="font-size-10px text-muted">{{t.description}}</div>
              </div>
            </div>
            <i class="fas fa-check-circle text-primary font-size-14px" *ngIf="currentTheme === t.id"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Grand Executive Branch & Role Selection Card -->
  <div class="ms-login-card-container">
    <div class="ms-login-card">
      
      <!-- Header & Logo -->
      <div class="ms-login-card-header">
        <div class="ms-login-logo-box">
          <img [src]='logo' [style.width.px]="logowidth || 160" [style.height.px]="logoheight || 54" onError="this.src='Navlogo.png';" alt="Healins Life Logo">
        </div>
        <div class="ms-welcome-pill margin-top-10px">
          <i class="fas fa-user-circle margin-right-6px"></i> Welcome back, <strong class="margin-left-4px text-capitalize">{{UserName}}</strong>
        </div>
        <p class="ms-login-subtitle margin-top-6px">Select your Branch & Role to continue</p>
      </div>

      <!-- Form Body -->
      <div class="ms-login-card-body">
        <!-- Branch Selection -->
        <div class="ms-login-field-group">
          <label class="ms-login-label">Branch <span class="text-danger">*</span></label>
          <div class="ms-login-input-wrapper">
            <i class="fas fa-hospital ms-login-field-icon"></i>
            <CustomDataByRequestType class="ms-login-custom-select"
                                     FontSize="14"
                                     RequestedType="FacilitiesByActor" [ActorCode]="ActorCode"
                                     (keyChange)="onAssignedToActorCode($event)"
                                     [(ngModel)]="SelectedBranchCode" name="SelectedBranchCode"
                                     ngDefaultControl
                                     required>
            </CustomDataByRequestType>
          </div>
        </div>

        <!-- Role Selection -->
        <div class="ms-login-field-group">
          <label class="ms-login-label">Role <span class="text-danger">*</span></label>
          <div class="ms-login-input-wrapper">
            <i class="fas fa-user-shield ms-login-field-icon"></i>
            <CustomDataByRequestType class="ms-login-custom-select"
                                     FontSize="14"
                                     RequestedType="RolesByActor" [ActorCode]="ActorCode"
                                     (keyChange)="Roleassign($event)"
                                     [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode"
                                     ngDefaultControl
                                     required>
            </CustomDataByRequestType>
          </div>
        </div>
      </div>

      <!-- Card Footer & Submit Button -->
      <div class="ms-login-card-footer" *ngIf="SelectedBranchCode > 0 && SelectedFacilityCode > 0">
        <form novalidate="" (ngSubmit)="onSubmit()" #f="ngForm" class="width-100pe">
          <button type="submit" [disabled]="isRequesting" class="ms-login-submit-btn">
            <span *ngIf="!isRequesting">Next <i class="fas fa-arrow-right margin-left-6px"></i></span>
            <span *ngIf="isRequesting"><i class="fas fa-spinner fa-spin margin-right-6px"></i> Loading...</span>
          </button>
        </form>
      </div>

    </div>
  </div>
</div>
